import React from "react";
import { Link } from "react-router-dom";

export default function SingleHotelCard(props) {
  const confirmDeletingHotel = () => {
    const confirmation = window.confirm("Are you sure you want to delete it?");
    if (confirmation === true) {
      props.deleteHandler(props.hotelId);
    } else {
      return;
    }
  };

  return (
    <div className="mb-4 single-place-cover">
      <div className="single-place main-card-cover h-100">
        {/* Image */}
        <div
          className="img-side mb-3"
          style={{ background: `url(${props.hotelImg})` }}
        ></div>
        {/* Details */}
        <div className="details-side">
          <h4 className="mb-3 text-capitalize">{props.hotelName}</h4>
          <p className="mb-2 text-capitalize">
            {props.hotelLocation}, {props.hotelCity}, {props.hotelCountry}
          </p>
          <p className="mb-2">{props.hotelPhone}</p>
          <p className="mb-2 text-capitalize">
            {props.hotelRating} - {props.hotelReview}
          </p>
          <p className="mb-2">Per day starts at ${props.hotelPrice}</p>
        </div>

        {/* Update and Delete Button */}
        <div className="update-delete-btns">
          <Link
            to={`/admin/edit-hotel/${props.hotelId}`}
            className="update-btn btn"
          >
            <i className="fa-solid fa-pen"></i>
          </Link>
          <button className="del-btn btn" onClick={confirmDeletingHotel}>
            <i className="fa-solid fa-trash"></i>
          </button>
        </div>
      </div>
    </div>
  );
}
